const productSliders = document.querySelectorAll(".collection__slider");
productSliders.forEach(el => {
    let next = el.querySelector(".swiper-navigation--next");
    let prev = el.querySelector(".swiper-navigation--prev");
    let carousel = el.querySelector(".swiper");
    let pagination = el.querySelector(".swiper-pagination");
let swiper = new Swiper(carousel, {
  loop: true,
  navigation: {
    nextEl: next,
    prevEl: prev
    },
  pagination: {
      el: pagination,
      clickable: true
  },
  slidesPerView: carousel.dataset.columnsMobile,
  spaceBetween: 20,
    breakpoints: {
        750: {
            slidesPerView: 2,
        },
        990: {
            slidesPerView: carousel.dataset.columnsDesktop,
        },
    }
});
});